var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-information-content"},[(!(_vm.config.contact == ''))?_c('ul',_vm._l((_vm.config.contact),function(info,i){return _c('li',{key:'contact-entry-' + i,class:'contact-entry-' + i},[_c('i',{class:info.icon}),_c('inline-edit',{attrs:{"element":"span","target":info.data}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }